export const luckyWheelConstant = {
    GET_LUCKY_WHEEL_DETAILS: 'GET_LUCKY_WHEEL_DETAILS',
    SET_LUCKY_WHEEL_IS_ENABLED: 'SET_LUCKY_WHEEL_IS_ENABLED'
};
